import { Redirect, Route, Switch } from 'react-router-dom'

interface DeviceRoute {
  component: (params: any) => JSX.Element
  path: string
}

interface HomeDevicesRoutesProps {
  defaultRoute: string
  devicesRoutes: DeviceRoute[]
}

function HomeDevicesRoutes(props: HomeDevicesRoutesProps) {
  const { defaultRoute, devicesRoutes } = props

  return (
    <Switch>
      {devicesRoutes.map(({ component, path }) => (
        <Route key={path} path={path} component={component} />
      ))}
      <Route path="*">
        <Redirect to={defaultRoute} />
      </Route>
    </Switch>
  )
}

export default HomeDevicesRoutes
